import { render } from "./Coworking.vue?vue&type=template&id=6ba1faab&scoped=true"
import script from "./Coworking.vue?vue&type=script&lang=js"
export * from "./Coworking.vue?vue&type=script&lang=js"

import "./Coworking.vue?vue&type=style&index=0&id=6ba1faab&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba1faab"]])

export default __exports__